const dsrstatic_cn=
{
    "container_number":"Container Number(s)",
    "container_types":"Container Types",
    "empty_container_pickup":"Empty Container Pick-up",
        "container_arrival_factory":"Empty Container Arrival at Factory",
        "loaded_and_dispatch":"Loaded & Dispatched",
        "container_handover":"Container Handover @ POR",
        "por_to_pol_movement":"Rail-out / Truck-out Status",
        "gatein_pol":"Gate-in @ POL",
        "gateout_to_fpod":"ATD from POD",
        "gatein_fpod":"ATA @ FPOD",
        "container_pickup_fpod":"Container Pick-up @ FPOD",
        "estimate_delivery_date_to_consignee":"Estimated Delivery Date to Consignee",
        "container_delivery":"Container Delivered to Consignee",
        "empty_return":"Empty Container Return to Carrier",
        "empty_container_arrival_at_por":"Container Arrival @ Origin CFS",
        "stuffing_confirmation":"CFS Stuffing Date",
        "container_arrival_at_fpod":"Container Arrival @ Destination CFS",
        "container_de_vanning":"Container De-vanning"
}


const dsrstatic_FCLFactoryFactory={
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name",
"cust_ref_number":"Customer Reference #",
"agraga_booking_#":"Agraga Booking Reference #",
"origin":"Origin",
"destination":"Destination",
"por":"Place of Receipt",
"pol":"Port of Loading",
"pod":"Port of Discharge",
"fpod":"Final Place of Delivery",
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
"gate_cut_off":"Gate Cut off",
"fl_vessel_name":"1st Leg Vessel Name",
"fl_vessel_number":"1st Leg Voyage #",
"etd_at_pol":"ETD @ POL",
"sob_pol":"Shipped-on-Board",
"hbl_number":"HBL #",
"mbl_number":"MBL #",
"arrival_notice":"Arrival Notice to Consignee",
"eta_fpod":"ETA @ FPOD",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
"status_closed": "Is the Booking Closed?",
}


const dsrstatic_FCLFactoryFactory_keys=[
"shipper_name",
"branch_name",
"consignee_name",
"cust_ref_number",
"agraga_booking_#",
"origin",
"destination",
"por",
"pol",
"pod",
"fpod",
"carrier_booking_ref_number",
"carrier_booking_release",
"vgm_cut_off",
"shipping_instructions_cut_off",
"gate_cut_off",
"empty_container_pickup",
"container_arrival_factory",
"loaded_and_dispatch",
"container_number",
"container_handover",
"por_to_pol_movement",
"gatein_pol",
"fl_vessel_name",
"fl_vessel_number",
'etd_at_pol',
"sob_pol",
"hbl_number",
"mbl_number",
"ts1_port",
'ts1_arrival_estimate',
"ts1_arrival",
'ts1_departure_estimate',
"ts1_departure",
"ts1_vessel_name",
"ts1_vessel_number",
"ts2_port",
'ts2_arrival_estimate',
"ts2_arrival",
'ts2_departure_estimate',
"ts2_departure",
"ts2_vessel_name",
"ts2_vessel_number",
"ts3_port",
'ts3_arrival_estimate',
"ts3_arrival",
'ts3_departure_estimate',
"ts3_departure",
"ts3_vessel_name",
"ts3_vessel_number",
"ts4_port",
'ts4_arrival_estimate',
"ts4_arrival",
'ts4_departure_estimate',
"ts4_departure",
"ts4_vessel_name",
"ts4_vessel_number",
"arrival_notice",
'eta_at_pod',
"pod_arrival",
"etd_pod",
"gateout_to_fpod",
"eta_fpod",
"gatein_fpod",
"last_free_date_at_fpod",
"delivery_order_release",
"container_pickup_fpod",
"estimate_delivery_date_to_consignee",
"container_delivery",
"empty_return",
"remarks",
"status_closed",
"containerlist",
"vorgin",
"vdes",
"_id",
"tsUpdatedOn",
"tsUpdatedBy",
"project44_1d"
]


const dsrstatic_FCLDockFactory =
{
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name", 
"cust_ref_number":"Customer Reference #",
"agraga_booking_#":"Agraga Booking Reference #",
"origin":"Origin",
"destination":"Destination",
"por":"Place of Receipt",
"pol":"Port of Loading",
"pod":"Port of Discharge",
"fpod":"Final Place of Delivery",
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
"gate_cut_off":"Gate Cut off",
"fl_vessel_name":"1st Leg Vessel Name",
"fl_vessel_number":"1st Leg Voyage #",
"etd_at_pol":"ETD @ POL",
"sob_pol":"Shipped-on-Board",
"hbl_number":"HBL #",
"mbl_number":"MBL #",
"arrival_notice":"Arrival Notice to Consignee",
"eta_fpod":"ETA @ FPOD",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
"status_closed": "Is the Booking Closed?",
}


const dsrstatic_FCLDockFactory_keys = [ 
"shipper_name",
"branch_name",
"consignee_name",
"cust_ref_number",
"agraga_booking_#",
"origin",
"destination",
"por",
"pol",
"pod",
"fpod",
"carrier_booking_ref_number",
"carrier_booking_release",
"vgm_cut_off",
"shipping_instructions_cut_off",
"gate_cut_off",
"empty_container_pickup",
"empty_container_arrival_at_por",
"container_number",
"stuffing_confirmation",
"container_handover",
"por_to_pol_movement",
"gatein_pol",
"fl_vessel_name",
"fl_vessel_number",
'etd_at_pol',
"sob_pol",
"hbl_number",
"mbl_number",
"ts1_port",
'ts1_arrival_estimate',
"ts1_arrival",
'ts1_departure_estimate',
"ts1_departure",
"ts1_vessel_name",
"ts1_vessel_number",
"ts2_port",
'ts2_arrival_estimate',
"ts2_arrival",
'ts2_departure_estimate',
"ts2_departure",
"ts2_vessel_name",
"ts2_vessel_number",
"ts3_port",
'ts3_arrival_estimate',
"ts3_arrival",
'ts3_departure_estimate',
"ts3_departure",
"ts3_vessel_name",
"ts3_vessel_number",
"ts4_port",
'ts4_arrival_estimate',
"ts4_arrival",
'ts4_departure_estimate',
"ts4_departure",
"ts4_vessel_name",
"ts4_vessel_number",
"arrival_notice",
'eta_at_pod',
"pod_arrival",
"etd_pod",
"gateout_to_fpod",
"eta_fpod",
"gatein_fpod",
"last_free_date_at_fpod",
"delivery_order_release",
"container_pickup_fpod",
"estimate_delivery_date_to_consignee",
"container_delivery",
"empty_return",
"remarks",
"status_closed",
"containerlist",
"vorgin",
"vdes",
"_id",
"tsUpdatedOn",
"tsUpdatedBy",
"project44_1d"
]


const dsrstatic_FCLFactoryDock = {
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name",
"cust_ref_number":"Customer Reference #",
"agraga_booking_#":"Agraga Booking Reference #",
"origin":"Origin",
"destination":"Destination",
"por":"Place of Receipt",
"pol":"Port of Loading",
"pod":"Port of Discharge",
"fpod":"Final Place of Delivery",
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
"gate_cut_off":"Gate Cut off",
"fl_vessel_name":"1st Leg Vessel Name",
"fl_vessel_number":"1st Leg Voyage #",
"etd_at_pol":"ETD @ POL",
"sob_pol":"Shipped-on-Board",
"hbl_number":"HBL #",
"mbl_number":"MBL #",
"arrival_notice":"Arrival Notice to Consignee",
"eta_fpod":"ETA @ FPOD",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
"status_closed": "Is the Booking Closed?",
}


const dsrstatic_FCLFactoryDock_keys = [
"shipper_name",
"branch_name",
"consignee_name",
"cust_ref_number",
"agraga_booking_#",
"origin",
"destination",
"por",
"pol",
"pod",
"fpod",
"carrier_booking_ref_number",
"carrier_booking_release",
"vgm_cut_off",
"shipping_instructions_cut_off",
"gate_cut_off",
"empty_container_pickup",
"container_arrival_factory",
"loaded_and_dispatch",
"container_number",
"container_handover",
"por_to_pol_movement",
"gatein_pol",
"fl_vessel_name",
"fl_vessel_number",
'etd_at_pol',
"sob_pol",
"hbl_number",
"mbl_number",
"ts1_port",
'ts1_arrival_estimate',
"ts1_arrival",
'ts1_departure_estimate',
"ts1_departure",
"ts1_vessel_name",
"ts1_vessel_number",
"ts2_port",
'ts2_arrival_estimate',
"ts2_arrival",
'ts2_departure_estimate',
"ts2_departure",
"ts2_vessel_name",
"ts2_vessel_number",
"ts3_port",
'ts3_arrival_estimate',
"ts3_arrival",
'ts3_departure_estimate',
"ts3_departure",
"ts3_vessel_name",
"ts3_vessel_number",
"ts4_port",
'ts4_arrival_estimate',
"ts4_arrival",
'ts4_departure_estimate',
"ts4_departure",
"ts4_vessel_name",
"ts4_vessel_number",
"arrival_notice",
'eta_at_pod',
"pod_arrival",
"etd_pod",
"gateout_to_fpod",
"eta_fpod",
"gatein_fpod",
"last_free_date_at_fpod",
"delivery_order_release",
"container_pickup_fpod",
"container_arrival_at_fpod",
"container_de_vanning",
"empty_return",
"remarks",
"status_closed",
"containerlist",
"vorgin",
"vdes",
"_id",
"tsUpdatedOn",
"tsUpdatedBy",
"project44_1d"
]

const dsrstatic_FCLDockDock = {
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name", 
"cust_ref_number":"Customer Reference #",
"agraga_booking_#":"Agraga Booking Reference #",
"origin":"Origin",
"destination":"Destination",
"por":"Place of Receipt",
"pol":"Port of Loading",
"pod":"Port of Discharge",
"fpod":"Final Place of Delivery",
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
"gate_cut_off":"Gate Cut off",
"fl_vessel_name":"1st Leg Vessel Name",
"fl_vessel_number":"1st Leg Voyage #",
"etd_at_pol":"ETD @ POL",
"sob_pol":"Shipped-on-Board",
"hbl_number":"HBL #",
"mbl_number":"MBL #",
"arrival_notice":"Arrival Notice to Consignee",
"eta_fpod":"ETA @ FPOD",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
"status_closed": "Is the Booking Closed?",
}


const dsrstatic_FCLDockDock_keys = [
"shipper_name",
"branch_name",
"consignee_name",
"cust_ref_number",
"agraga_booking_#",
"origin",
"destination",
"por",
"pol",
"pod",
"fpod",
"carrier_booking_ref_number",
"carrier_booking_release",
"vgm_cut_off",
"shipping_instructions_cut_off",
"gate_cut_off",
"empty_container_pickup",
"empty_container_arrival_at_por",
"container_number",
"stuffing_confirmation",
"container_handover",
"por_to_pol_movement",
"gatein_pol",
"fl_vessel_name",
"fl_vessel_number",
'etd_at_pol',
"sob_pol",
"hbl_number",
"mbl_number",
"ts1_port",
'ts1_arrival_estimate',
"ts1_arrival",
'ts1_departure_estimate',
"ts1_departure",
"ts1_vessel_name",
"ts1_vessel_number",
"ts2_port",
'ts2_arrival_estimate',
"ts2_arrival",
'ts2_departure_estimate',
"ts2_departure",
"ts2_vessel_name",
"ts2_vessel_number",
"ts3_port",
'ts3_arrival_estimate',
"ts3_arrival",
'ts3_departure_estimate',
"ts3_departure",
"ts3_vessel_name",
"ts3_vessel_number",
"ts4_port",
'ts4_arrival_estimate',
"ts4_arrival",
'ts4_departure_estimate',
"ts4_departure",
"ts4_vessel_name",
"ts4_vessel_number",
"arrival_notice",
'eta_at_pod',
"pod_arrival",
"etd_pod",
"gateout_to_fpod",
"eta_fpod",
"gatein_fpod",
"last_free_date_at_fpod",
"delivery_order_release",
"container_pickup_fpod",
"container_arrival_at_fpod",
"container_de_vanning",
"empty_return",
"remarks",
"status_closed",
"containerlist",
"vorgin",
"vdes",
"_id",
"tsUpdatedOn",
"tsUpdatedBy",
"project44_1d"
]

const dsrstatic_LCL ={
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name",
'cust_ref_number':'Customer Reference #',
'agraga_booking_#':'Agraga Booking Reference #',
'origin':'Origin',
'destination':'Destination',
'carrier':'Carrier',
'stuffing_confirmation':'Stuffing Confirmation',
'por':'Place of Receipt',
'pol':'Port of Loading',
"gatein_pol":"Gate-in at POL",
'pol_container_number':'POL Container #',
'hbl_number':'HBL Number',
'mbl_number':'MBL Number',
"etd_at_pol":"ETD @ POL",
'sob_pol':'Shipped-on-Board',
'gatein_reworking':'Container Gate-in at Re-working Port',
'new_carrier_name':'New Carrier Name',
'new_carrier_mbl_number':'New Carrier MBL Number',
'pod':'Port of Discharge (POD)',
'fpod':'Final Place of Delivery (FPOD)',
'eta_fpod':'ETA @ FPOD',
'gatein_fpod':'ATA @ FPOD',
'destuffing_fpod':'De-stuffing Status @ fpod',
"last_free_date_at_fpod":"Last Free Date @ FPOD",
'arrival_notice':'Arrival Notice to Consignee',
'delivery_order_release':'Delivery Order Release to Consignee',
"consolidator":"Consolidator",
'remarks':'Special Remarks',      
"status_closed": "Is the Booking Closed?",
}

const dsrstatic_LCL_keys=[

'shipper_name',
'branch_name',
'consignee_name',
'cust_ref_number',
'agraga_booking_#',
'origin',
'destination',
"por",
"pol",
"pod",
"fpod",
'carrier',
"consolidator",
'stuffing_confirmation' ,
'container_handover' ,
'por_to_pol_movement' ,
'pol_arrival' ,
'rail_yard_to_cfs' ,
'destuffing_at_pol' ,
'restuffing_at_pol' ,
'gatein_pol' ,
'pol_container_number',
'hbl_number',
'mbl_number',
'etd_at_pol' ,
'sob_pol' ,
'reworking_pol_port',
'reworking_pol_arrival_estimate',
                        "reworking_pol_arrival",
                        'reworking_pol_departure_estimate',
                        "reworking_pol_departure",
                        "reworking_pol_vessel_name",
                         "reworking_pol_vessel_number",
                         'reworking_pol_destuffing',
                        "reworking_pol_restuffing",
                        "reworking_pol_container_number",
                        
"ts1_port",
'ts1_arrival_estimate',
"ts1_arrival",
'ts1_departure_estimate',
"ts1_departure",
"ts1_vessel_name",
"ts1_vessel_number",
"ts2_port",
'ts2_arrival_estimate',
"ts2_arrival",
'ts2_departure_estimate',
"ts2_departure",
"ts2_vessel_name",
"ts2_vessel_number",
"ts3_port",
'ts3_arrival_estimate',
"ts3_arrival",
'ts3_departure_estimate',
"ts3_departure",
"ts3_vessel_name",
"ts3_vessel_number",
"ts4_port",
'ts4_arrival_estimate',
"ts4_arrival",
'ts4_departure_estimate',
"ts4_departure",
"ts4_vessel_name",
"ts4_vessel_number",
'reworking_pod_port',
'reworking_pod_arrival_estimate',
"reworking_pod_arrival",
'reworking_pod_departure_estimate',
"reworking_pod_departure",

 "reworking_pod_vessel_name",
 "reworking_pod_vessel_number",
 
'reworking_pod_destuffing',
"reworking_pod_restuffing",
"reworking_pod_container_number",
'gatein_reworking' ,
'new_carrier_name',
'new_carrier_mbl_number',
'reworking_container_number',
'reworking_departure_estimate' ,
'sob_reworking' ,
'reworking_departure_actual' ,
'eta_at_pod' ,
'pod_arrival' ,
'etd_pod' ,
'gateout_to_fpod' ,
'eta_fpod' ,
'gatein_fpod' ,
'destuffing_fpod' ,
'last_free_date_at_fpod' ,
'arrival_notice' ,
'delivery_order_release' ,
'cargo_picked_up_by_consignee',
'remarks',
"status_closed",
"vorgin",
"vdes",
"reworking_at_pol",
"_id",
"tsUpdatedOn",
"tsUpdatedBy",
"project44_1d"

]


const dsrstatic_Air ={
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name",
"cust_ref_number": "Customer Reference #",
"agraga_booking_#": "Agraga Booking Reference #",
"origin": "Origin",
"destination": "Destination",
"departure_airport": "Airport of Departure",
"arrival_airport":"Airport of Arrival",
"airline_booking_release": "Airline Release Order",
"airline_booking_ref_number": "Airline Booking Reference #",
"etd_airport_of_departure":"ETD Airport of Departure",
"loaded_on_board": "Loaded-on-Board",
"flight_number_departure_airport":"Flight Number from Departure Airport",
"hawb_number": "HAWB Number",
"mawb_number": "MAWB Number",
"ts1_airport": "Transhipment 1 Airport (if any)",
"ts1_arrival_estimate":"ETA Transhipment 1",
"ts1_arrival":"ATA Transhipment 1",
"flight_number_ts1": "Flight Number from Transhipment 1 Airport",
"ts1_departure_estimate":"ETD Transhipment 1",
"ts1_departure":"ATD Transhipment 1",
"ts2_airport": "Transhipment 2 Airport (if any)",
"ts2_arrival_estimate":"ETA Transhipment 2",
"ts2_arrival":"ATA Transhipment 2",
"flight_number_ts2": "Flight Number from Transhipment 2 Airport",
"ts2_departure_estimate":"ETD Transhipment 2",
"ts2_departure":"ATD Transhipment 2",
"eta_at_arrival_airport":"ETA @ Arrival Airport",
"ata_at_arrival_airport":"ATA @ Arrival Airport",
"arrival_notice": "Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release": "Delivery Order Released to Consignee",
"remarks": "Special Remarks",
"status_closed": "Is the Booking Closed?",
}


const dsrstatic_Air_keys = [
"shipper_name",
"branch_name",
"consignee_name",
"cust_ref_number",
"agraga_booking_#",
"origin",
"destination",
"departure_airport",
"arrival_airport",
"airline_booking_release",
"airline_booking_ref_number",
"etd_airport_of_departure",
"loaded_on_board",
"flight_number_departure_airport",
"hawb_number",
"mawb_number",
"ts1_airport",
"ts1_arrival_estimate",
"ts1_arrival",
"flight_number_ts1",
"ts1_departure_estimate",
"ts1_departure",
"ts2_airport",
"ts2_arrival_estimate",
"ts2_arrival",
"flight_number_ts2",
"ts2_departure_estimate",
"ts2_departure",
"eta_at_arrival_airport",
"ata_at_arrival_airport",
"arrival_notice",
"last_free_date_at_fpod",
"delivery_order_release",
"remarks",
"status_closed",
"vorgin",
"vdes",
"_id",
"tsUpdatedOn",
"tsUpdatedBy"
]

const dsrstatic_FactoryFactoryViewDetailsKeys = {
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
"hbl_number":"HBL #",
"arrival_notice":"Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
}

const dsrstatic_DockFactoryViewDetailsKeys = {
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
"stuffing_confirmation":"Stuffing Confirmation",
"hbl_number":"HBL #",
"arrival_notice":"Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
}

const dsrstatic_FactoryDockViewDetailsKeys = {
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
"hbl_number":"HBL #",
"arrival_notice":"Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
}

const dsrstatic_DockDockViewDetailsKeys = {
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
"hbl_number":"HBL #",
"arrival_notice":"Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
} 

const dsrstatic_AirViewDetailsKeys={
"airline_booking_release": "Airline Release Order",
"airline_booking_ref_number": "Airline Booking Reference #",
"flight_number_departure_airport":"Flight Number from Departure Airport",
"hawb_number": "HAWB Number",
"mawb_number": "MAWB Number",
"flight_number_ts1": "Flight Number from Transhipment 1 Airport",
"flight_number_ts2": "Flight Number from Transhipment 2 Airport",
"arrival_notice": "Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release": "Delivery Order Released to Consignee",
"remarks": "Special Remarks",
}

const dsrstatic_LCLViewDetailsKeys={
'carrier':'Carrier',
'stuffing_confirmation':'Stuffing Confirmation',
"destuffing_at_pol":"De-stuffing Status",
"restuffing_at_pol":"Re-stuffing Status",
"pol_container_number":"POL Container #",
'hbl_number':'HBL Number',
'mbl_number':'MBL Number',
"destuffing_reworking":"De-stuffing @ Re-working Port",
"restuffing_reworking":"Re-stuffing @ Re-working Port",
'new_carrier_name':'New Carrier Name',
'new_carrier_mbl_number':'New Carrier MBL Number',
"reworking_container_number":"Re-working Container #",
"destuffing_fpod":"De-stuffing Status @ fpod",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
'arrival_notice':'Arrival Notice to Consignee',
'delivery_order_release':'Delivery Order Release to Consignee',
'remarks':'Special Remarks',    
}

export {
    dsrstatic_cn,
dsrstatic_FCLFactoryFactory,
dsrstatic_FCLFactoryFactory_keys,
dsrstatic_FCLDockFactory,
dsrstatic_FCLDockFactory_keys,
dsrstatic_FCLFactoryDock,
dsrstatic_FCLFactoryDock_keys,
dsrstatic_FCLDockDock,
dsrstatic_FCLDockDock_keys,
dsrstatic_LCL,
dsrstatic_LCL_keys,
dsrstatic_Air,
dsrstatic_Air_keys,
dsrstatic_FactoryFactoryViewDetailsKeys,
dsrstatic_DockFactoryViewDetailsKeys,
dsrstatic_FactoryDockViewDetailsKeys,
dsrstatic_DockDockViewDetailsKeys,
dsrstatic_AirViewDetailsKeys,
dsrstatic_LCLViewDetailsKeys
}